import { render } from "./Select.vue?vue&type=template&id=dfd7e2fa&scoped=true&ts=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=dfd7e2fa&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd7e2fa"]])

export default __exports__